import * as React from 'react';
import { Layout } from 'components/Layout';
import { HeroProduct } from 'components/HeroProduct';
import { FormSection } from 'components/FormSection';
import { RelatedProducts } from 'components/RelatedProducts';
import { AdvantageList } from 'components/AdvantageList';
import { Faq } from 'components/Faq';
import { usePortableSections } from '@lcifr/components/portable-sections';
import { VideoSection } from 'components/VideoSection';

export type ProductProps = {
  pageData: any;
};

export default function Product({ pageData }: ProductProps) {
  const footer = (pageData as any)?.pageDocument?.page?.footer;
  const header = {
    ...(pageData as any)?.i18n?.header,
    hasNoTopBackground: true,
  };
  const socialProfiles = (pageData as any)?.i18n?.socialProfiles;
  const PortableSections = usePortableSections();

  return (
    <Layout header={header} footer={footer} socialProfiles={socialProfiles}>
      <HeroProduct
        pageId={pageData?.pageDocument?._id}
        image={pageData?.pageDocument?.imageCutout}
        headline={pageData?.pageDocument?.name}
        intro={pageData?.pageDocument?.intro}
        downloadTextGlobal={pageData?.i18n?.pageProduct?.downloadText}
        downloadList={pageData?.pageDocument?.downloadList}
      />
      <AdvantageList advantageList={pageData?.pageDocument?.advantages} />
      {pageData?.pageDocument?.content && (
        <PortableSections blocks={pageData?.pageDocument?.content}>
          {(children) => <>{children}</>}
        </PortableSections>
      )}
      <VideoSection videoList={pageData?.pageDocument?.videoList} />
      <Faq faqList={pageData?.pageDocument?.faqList} spaceT={4} hasLink />
      <FormSection variant="formFermenter" spaceB={9} />
      <RelatedProducts
        productList={(pageData as any)?.i18n?.relatedProducts?.productList}
        headline={(pageData as any)?.i18n?.relatedProducts?.headline}
        link={(pageData as any)?.i18n?.relatedProducts?.link}
        linkText={(pageData as any)?.i18n?.relatedProducts?.linkText}
        spaceB={9}
        hideButton={false}
      />
    </Layout>
  );
}
